import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import {
  collectionCurrentPageSelector,
  collectionSelector,
  getContainerWideSelector,
  getCurrentPageNumberSelector,
  getVideosPerPageSelector,
  integrationSelector,
  userIdSelector,
  websiteSelector,
} from 'common/selectors';
import { urlVideoIdSelector } from 'pages/channel.page';
import { urlSortSelector } from 'common/selectors/router';
import { collectionResetAction } from 'common/actions';
import { DeleteMyVideoDialog } from './fragments/delete-my-video-dialog';
import { myVideosSelector } from './selectors';
import { postDeleteAction } from './actions';
import { MyVideosPageView } from './view';

class MyVideosPage extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.myVideos !== prevProps.myVideos) {
      if (this.props.myVideos.deletedVideoId) {
        this.props.postDelete(this.props.match.params.pageNumber);
      }
    }
  }

  componentWillUnmount() {
    this.props.resetCollection();
  }

  findVideoFromCollection = (videoId) => this.props.collection.videos.find((video) => video.id === videoId);

  render() {
    return (
      <Fragment>
        <DeleteMyVideoDialog video={this.findVideoFromCollection(this.props.myVideos.deleteVideoId)} />
        <MyVideosPageView
          userId={this.props.userId}
          sort={this.props.sort}
          videoId={this.props.videoId}
          integration={this.props.integration}
          website={this.props.website}
          collection={this.props.collection}
          pageNumber={this.props.pageNumber}
          perPage={this.props.perPage}
        />
      </Fragment>
    );
  }
}

export const MyVideosPageDecorated = compose(
  withRouter,
  connect(
    (state, props) => ({
      collection: collectionSelector(state),
      pageNumber: getCurrentPageNumberSelector(state, props.match),
      collectionPageNumber: collectionCurrentPageSelector(state),
      videoId: urlVideoIdSelector(state, props.match),
      website: websiteSelector(state),
      sort: urlSortSelector(state, props.match),
      containerWide: getContainerWideSelector(state),
      integration: integrationSelector(state),
      userId: userIdSelector(),
      myVideos: myVideosSelector(state),
      perPage: getVideosPerPageSelector(state),
    }),
    (dispatch) => ({
      resetCollection: () => dispatch(collectionResetAction()),
      postDelete: (pageNumber) => dispatch(postDeleteAction(pageNumber)),
    })
  )
)(MyVideosPage);

export * from './reducer';
export * from './view';
export * from './actions';
export * from './saga';
export * from './selectors';
export * from './edit.page';
export * from './fragments';
export * from './effects';
